<template>
    <div class="body">
        <header-select />
        <div class="main">
            <div class="nav_banner1">
                <my-menu></my-menu>
                <div class="nr_banner">
                    <img src="@/assets/images/information_banner.jpg" width="965" height="207" alt="康柏汉森医生数据库查询管理平台" title="康柏汉森医生数据库查询管理平台" />
                </div>
            </div>
            <div class="er_main" >
                <advisory-item :datalist="datalist" ></advisory-item>
            </div>
            <div class="clear"></div>
            <div class="footer">
                <my-footer></my-footer>
            </div>
        </div>
    </div>
</template>

<script>
    import headerSelect from "@/views/Component/header";
    import myMenu from "@/views/Component/myMenu";
    import myFooter from "@/views/Component/myFooter";
    import advisoryItem from "@/views/Information/childPage/informationItem";
    export default {
        name: "InformationYssjjk",
        metaInfo:{
            title:'北京康柏汉森医药科技咨询有限责任公司',
            meta:[{name: 'keyWords', content:'医生数据库管理平台，官网，CHPC，医药咨询，康柏汉森，医药科技咨询；医药企业营销咨询；企业管理咨询；商务咨询'},
                {name:'description', content:'简称CHPC, CHPC起步于医药行业,中国医药行业内风险控制领域的服务提供商，提供渠道核查、合规核查、信息技术、管理咨询服务'},
                {name:"robots",content:"官网，中国医药行业内风险控制领域的服务提供商"},
            ]
        },
        data() {
            return {
                datalist: {},
            }
        },
        components:{
            headerSelect,myMenu,myFooter,advisoryItem
        },
        mounted() {
            document.body.style.backgroundColor = '#daecec';
            this.getInfo();
        },
        methods: {
            getInfo(){
                let query ={fieldCode:'yssjk'};
                this.$HTTP.getContentDetailById(query).then(resp => {
                    if(resp.code == 200){
                        let data = resp.data;
                        this.datalist =data;
                    }
                });
            },
        },
        computed: {

        },
        watch: {
        },
        beforeDestroy() {
        }
    }
</script>

<style lang="scss" scoped>
    *{ margin:0; padding:0;}
    .body{ color:#666; font:12px "宋体";background:#daecec;}
    .main{width:1001px;height:auto !important;height:500px;min-height:500px;margin:0 auto;background:url("../../assets/images/bg_main_07.jpg") repeat-y;border:1px solid #d9dde2;margin-bottom:50px;}
    .nav_banner1{width:1001px;height:305px;position:relative;}
    .nr_banner{width:965px;height:207px;position:absolute;left:17px;top:98px;}

</style>
